import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";

import { selectContactById } from "../../store/selectors/contacts";
import { selectAuthenticatedUser } from "../../store/selectors/auth";

import ContactDetails from "./ContactDetails";
import ContactDocuments from "./ContactDocuments";
import ContactNotes from "./ContactNotes";
import Tabs from "../../components/Tabs";
import WithNavigation from "../../layouts/WithNavigation";
import ContactServiceRequests from "./ContactServiceRequests";
import Loader from "../../components/Loader";
import { fetchFaqsNotesDocuments } from "../../store/actions/faqsNotesDocuments";
import { clearServiceRequests } from "../../store/actions/serviceRequests";

import {
  selectNotes,
  selectDocuments,
} from "../../store/selectors/faqsNotesDocuments";
import {
  fetchContacts,
  updateContact,
  deleteContactById,
  fetchContactCounts,
} from "../../store/actions/contacts";
import { upload } from "../../helpers/upLoadHelper";
import { selectFormOptions } from "../../store/selectors/formOptions";
import { resetUserPassword, activateUser } from "../../store/actions/auth";
import { selectContactServiceRequests } from "../../store/selectors/contacts";
import { selectServiceRequests } from "../../store/selectors/serviceRequests";
import { clearCountsDone } from "../../store/actions/properties";
import { selectCounts } from "../../store/selectors/Counts";
import ContactProperties from "./ContactProperties";
import { BrandingContext } from "../../branding/BrandingContextProvider";

class Contact extends Component {
  state = {
    noteVisibleToHomeownerOccupantRealtor:false,
  };
  componentDidMount() {
    const {
      onFetchContacts,
      onFetchNotesAndDocuments,
      match,
      clearServiceRequests,
      user,
      clearCountsDone,
      contact,
      notes
    } = this.props;
    let HmeOwnrOcpntRltrNotes=[];
    if(notes!=undefined && notes!=null && notes!="" && notes.length >0){
      let notesList= notes.filter(x=>x.documentType=="NOTES");
      if(notesList.length >0){
        notesList.forEach((object) => {HmeOwnrOcpntRltrNotes.push(JSON.parse(JSON.parse(JSON.stringify(object.data)))); });
      }
      if(HmeOwnrOcpntRltrNotes.length >0){
        let filterNotes=HmeOwnrOcpntRltrNotes.filter(x=>x.noteVisibleToHomeownerOccupantRealtor==true);
        if(filterNotes.length >0){
          this.setState({ noteVisibleToHomeownerOccupantRealtor: true });
        }
      }
    } 
    onFetchContacts(user.id, user.roles[0].role.name);

    clearCountsDone();
    clearServiceRequests();
    let contactId = match.params.id.split("&");
    if (contact && contact.roles && contact.roles.length > 0) {
      this.props.onFetchContactCounts(contactId[0], contact.roles[0].role.name);
    }
    onFetchNotesAndDocuments(contactId[0]);
  }

  onSubmitContactForm = async (data) => {
    const { user } = this.props;
    let imageUrl = null;
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }
    let assignedRoles = [];
    if (data.userRole) {
      for (var i = 0; i < this.props.formOptions.allRoles.length; i++) {
        if (data.userRole === this.props.formOptions.allRoles[i].name) {
          assignedRoles.push(this.props.formOptions.allRoles[i].id);
        }
      }
    }
    if (!data.userRole) {
      assignedRoles.push(data.roles[0].role.id);
    }

    let phone = data.phone;
    let cleaned = ("" + phone).replace(/\D/g, "");
    let formattedNumber = cleaned;
    if (cleaned.length === 10) {
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      formattedNumber = match[1] + "-" + match[2] + "-" + match[3];
    }
    let firstChar = data.firstname.charAt(0)?.toUpperCase();
    let slicedName = data.firstname.slice(1, data.firstname.length);
    let firstname = firstChar + slicedName;

    let PropertyId =
      data.userRole === "Service Provider" || data.userRole === "Vendor"
        ? null
        : data.propertyId
        ? data.propertyId
        : null;
    let SuiteId =
      data.userRole === "Service Provider" || data.userRole === "Vendor"
        ? null
        : data.suiteId
        ? data.suiteId
        : null;
    let ServiceProvided =
      data.userRole === "Service Provider" || data.userRole === "Vendor"
        ? data.servicesProvided
        : null;

    if (data.id) {
      let params = {
        id: data.id,
        username: data.username,
        email: data.email,
        firstname: firstname,
        lastname: data.lastname,
        phone: formattedNumber,
        profileImage: imageUrl != null ? imageUrl : data.profileImage,

        languages: null,
        customerId: null,
        deleted: false,
        assignedRoles: assignedRoles,
        address: data.address,
        UserId: user.id,
        // "AdvancedScheduling": data.AdvancedScheduling ? 'Enabled': 'Disabled',
        SendActivationLink: data.sendActivationEmail
          ? data.sendActivationEmail
          : false,
        IsMultiSelect: true,
        RoleName: data.userRole,
        RoleId: assignedRoles[0],
        "CompanyName":data.companyName

      };
      if (data.userRole === "Service Provider" || data.userRole === "Vendor") {
        params.ServicesProvided = ServiceProvided;
      }
      if (data.userRole === "Home Owner") {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.PropertyId,
        }));
        // params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }
      if (data.userRole === "Occupant") {
        params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }
      if (
        data.userRole === "Service Provider" ||
        data.userRole === "Property Developer"
      ) {
        params.CalendarLink =
          data && data.calendarLink ? data.calendarLink.trim() : "";
        params.PersonalEmail =
          data && data.personalEmail ? data.personalEmail : "";
      }
      if(data.userRole === 'Service Manager') {
        params.PropertyId = PropertyId;
      }
      this.props.onUpdateContactForm(params);
    }
  };

  onDeleteContact = (data) => {
    this.props.onDeleteContactById(data.id, this.props.history);
  };

  sendActivationLinkToUser = (data) => {
    this.props.activateUser(data, {
      UserId: data.id,
    });
  };

  sendResetPasswordLinkToUser = (data) => {
    this.props.resetUserPassword(data);
  };

  static contextType = BrandingContext;

  render() {
    const { contact, contactServiceRequests, counts } = this.props;
    const {branding} = this.context;
    // let contact = this.props.location.state.data;
    const { notes, documents, match } = this.props;
    const contactId = match.params.id.split("&");
    const navFrom = contactId.length === 2 ? contactId[1] : "";
    let homeOwnerCheck =
      contact &&
      contact.roles &&
      contact.roles.length > 0 &&
      (contact.roles[0].role.name === "Home Owner" ||
        contact.roles[0].role.name === "Occupant")
        ? true
        : false;
    let location = this.props.location;
    let isFromDashBoard =
      location &&
      location.state &&
      location.state.isFromDashBoard &&
      location.state.isFromDashBoard === true
        ? true
        : false;
        let {noteVisibleToHomeownerOccupantRealtor}=this.state;
    if (contact) {
      return (
        <WithNavigation
          title={`${contact.firstname} ${contact.lastname}`}
          top={
            <ContactDetails
              isFromDashBoard={isFromDashBoard}
              navFrom={navFrom}
              contact={contact}
              onSubmitContactForm={this.onSubmitContactForm}
              onDeleteContact={this.onDeleteContact}
              sendResetPasswordLinkToUser={(data) =>
                this.sendResetPasswordLinkToUser(data)
              }
              sendActivationLinkToUser={(data) =>
                this.sendActivationLinkToUser(data)
              }
              counts={counts}
            />
          }
          bottom={
            <Tabs
              from={'Contact'}
              items={[
                {
                  label: branding.text.serviceRequest+"s",
                  count: counts.serviceRequestsCount
                    ? counts.serviceRequestsCount
                    : "0",
                  content: <ContactServiceRequests contact={contact} />,
                },
                {
                  label: "Manuals & Documents",
                  count: counts.documentsCount ? counts.documentsCount : "0",
                  content: <ContactDocuments contact={contact} />,
                },

                homeOwnerCheck
                  ? {
                      label: "Properties",
                      count: counts.propertiesCount
                        ? counts.propertiesCount
                        : "0",
                      content: <ContactProperties contact={contact} />,
                    }
                  : {},
                ((homeOwnerCheck ||  contact.roles[0].role.name === "Realtor") && noteVisibleToHomeownerOccupantRealtor==false)
                  ? {}
                  : {
                      label: "Notes",
                      count: counts.notesCount ? counts.notesCount : "0",
                      content: <ContactNotes contact={contact} />,
                    },
              ]}
            />
          }
        />
      );
    }

    return <Loader />;
  }
}

const mapStateToProps = (state, ownProps) => {
  let contactId = ownProps.match.params.id.split("&");
  let contact = selectContactById(state, contactId[0]);
  let contactServiceRequests = selectServiceRequests(state);
  return {
    contact,
    notes: selectNotes(state),
    documents: selectDocuments(state),
    formOptions: selectFormOptions(state),
    contactServiceRequests,
    counts: selectCounts(state),
    user: selectAuthenticatedUser(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearCountsDone: clearCountsDone,
      clearServiceRequests,
      onFetchContacts: fetchContacts,
      onFetchContactCounts: fetchContactCounts,
      onFetchNotesAndDocuments: fetchFaqsNotesDocuments,
      onUpdateContactForm: updateContact,
      onDeleteContactById: deleteContactById,
      resetUserPassword,
      activateUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
